import React from 'react';
import { Field } from 'formik';

const Textarea = ({ name, rows, placeholder, disabled, showErrorMessages = true, maxLength = '200' }) => (
  <Field name={name}>
    {({ field, meta }) => (
      <div className={`app-input-text${field.name === 'chargeReason' ? ' charge-reason-textarea flex-grow-1' : ''}`} style={{width:"100%"}}>
        <textarea
          className={`${meta.touched && meta.error ? '' : ''}${field.name === 'chargeReason' ? ' charge-reason' : ''}`}
          name={field.name}
          maxLength={`${field.name === 'chargeReason' ? '50' : maxLength}`}
          disabled={disabled ?disabled :false}
          rows={rows}
          placeholder={placeholder}
          value={field.value || ''}
          {...field}
        />
        {meta.touched && meta.error && showErrorMessages && (
          <p name={name + 'Error'} className="error-message">{meta.error}</p>
        )}
      </div>
    )}
  </Field>
);

export default Textarea;
